import script from "./SharePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharePage.vue?vue&type=script&setup=true&lang=ts"

import "./SharePage.vue?vue&type=style&index=0&id=66b6b527&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66b6b527"]])

export default __exports__